import type { Provider } from '@angular/core';

import { provideTellentAssistantRenderPresenter } from '@core/tellent-assistant-contracts';

import { PresentTableDataComponent } from '../present-table-data/present-table-data.component';

export const providePresentTableDataClientTool: Provider = provideTellentAssistantRenderPresenter({
  useValue: { id: 'presentTableData', component: PresentTableDataComponent },
});
